import { t } from '@lingui/core/macro';
import { TFilter } from 'types';
import {
  ALL_STATUS_VALUES,
  EXPIRING_STATUS_VALUES,
  OFFERED_STATUS_VALUES,
  PENDING_STATUS_VALUES,
} from 'utils/applications/applications.config';

export const isExpiring = (timeout: string) => {
  const todaysDate = new Date();
  const timeoutDate = new Date(timeout);
  timeoutDate.setUTCHours(23, 59, 59, 999);
  const daysTilExpiry = Math.round(
    (timeoutDate.getTime() - todaysDate.getTime()) / (1000 * 3600 * 24),
  );
  if (daysTilExpiry >= 0 && daysTilExpiry <= 5) {
    return true;
  }
  return false;
};

export const FILTER_OPTIONS = (): TFilter[] => [
  {
    id: 'all',
    label: t`All apps`,
    propertiesToFilterOn: ALL_STATUS_VALUES,
  },
  {
    id: 'pending',
    label: t`Pending`,
    propertiesToFilterOn: PENDING_STATUS_VALUES,
    displayQuantity: true,
  },
  {
    id: 'review',
    label: t`Offered`,
    propertiesToFilterOn: OFFERED_STATUS_VALUES,
    displayQuantity: true,
  },
  {
    id: 'expiring',
    label: t`Expiring`,
    propertiesToFilterOn: EXPIRING_STATUS_VALUES,
    displayQuantity: true,
  },
];
